import React from 'react';
import { connect } from 'react-redux';

import { clearApiResponseInfo } from '../store/slices/apiResponseInfoSlice';

const UnknownApiFailure = (props) => (
  <div>
    <h1>Unknown Error Calling API</h1>
    <h3>Something failed while accessing {props.apiResponseInfo.callDescrip}.</h3>
    <h3>Error code: {props.apiResponseInfo.code}</h3>
  </div>
);

const mapStateToProps = (state) => ({ apiResponseInfo: state.apiResponseInfo });
export default connect(mapStateToProps, { clearApiResponseInfo })(UnknownApiFailure);
